import { render, staticRenderFns } from "./VariantsForm.vue?vue&type=template&id=1c13286a"
import script from "./VariantsForm.vue?vue&type=script&lang=js"
export * from "./VariantsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports